"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalStatus = void 0;
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["NotApproved"] = "Not Approved";
    ApprovalStatus["Approved"] = "Approved";
    ApprovalStatus["Rejected"] = "Rejected";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
//# sourceMappingURL=Appraisal.js.map